module.exports = __webpack_public_path__ + "media/images/icon-star-half-a470fc070959b82f32c50d372b57c1b4.svg";